/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { SyntheticEvent, useEffect, useState } from 'react'
import {KTSVG} from '../../../../../../_metronic/helpers'
import { useAppSelector, useAppDispatch } from "../../../../../redux/hook";
// import { useGetAllMediasQuery } from '../../../../redux/slices/media/apiMediaSlice';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { styled, withStyles } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import { AccordionProps } from '@mui/material/Accordion';
import {  AccordionSummaryProps, } from '@mui/material/AccordionSummary';
import { Box } from '@mui/material';
import moment from 'moment';
import { 
  AlignmentList,
  DimensionsList,
  Element,
  Source,
  TransitionList,
  secondsToHHmmss, 
  toCapitalize
} from '../../../../../redux/slices/content/contentModels';
import { setCheckSum, setContentSource, setHoverLayerId, setHoverLayerOrder, setHoverLayerSourceId, setHoverSectionId, setLayerId, setLayerOrder, setSectionId, setUnselectedSectionIds } from '../../../../../redux/slices/content/contentSlice';
import Swal from 'sweetalert2';
import { DEBUG_MODE, getSectColorCodes, getSectionIcon } from '../../../../../redux/slices/editor/editorModels';
import { SettingsSuggest } from '@mui/icons-material';
import { RenderedHtmlText } from '../../EditorComponents';
import { setTemplateSettings } from '../../../../../redux/slices/editor/editorSlice';

//----------------------------------------

type Props = {
  className?: string,
}

// const Accordion = styled((props: AccordionProps) => (
//   <MuiAccordion disableGutters elevation={0} square {...props} />
// ))(({ theme }) => ({
//   border: `1px solid ${theme.palette.divider}`,
//   '&:not(:last-child)': {
//     borderBottom: 0,
//   },
//   '&:before': {
//     display: 'none',
//   },
// }));

// const AccordionSummary = styled((props: AccordionSummaryProps) => (
//   <MuiAccordionSummary
//     expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
//     {...props}
//   />
// ))(({ theme }) => ({
//   backgroundColor:
//     theme.palette.mode === 'dark'
//       ? 'rgba(255, 255, 255, .05)'
//       : 'rgba(0, 0, 0, .03)',
//   flexDirection: 'row-reverse',
//   '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
//     transform: 'rotate(90deg)',
//   },
//   '& .MuiAccordionSummary-content': {
//     marginLeft: theme.spacing(1),
//   },
// }));

// const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
//   padding: theme.spacing(2),
//   borderTop: '1px solid rgba(0, 0, 0, .125)',
// }));

// const Accordion = withStyles({
//   root: {
//     "&$expanded": {
//       margin: "auto"
//     }
//   },
//   expanded: {}
// })(MuiAccordion);


//----------------------------------------
const AccordionTemplateSections: React.FC<Props> = ({className}) => {
  
  const dispatch = useAppDispatch()  
  //-----------------------------------------
  const currPersistContent = useAppSelector(state => state.persistor._content.currContent)  
  // console.log("currPersistContent in Accordion",currPersistContent)

  const currPersistTemplate = useAppSelector(state => state.persistor._template.currTemplate)  
  // console.log("currPersistTemplate in Accordion",currPersistTemplate)

  // console.log("--------------------------------------------------------")
  const unselectedSectIds = useAppSelector(state => state.content.unselectedSectionIds)  
  // console.log('unselectedSectIds:', unselectedSectIds)
  const currSectId = useAppSelector(state => state.content.currSectionId)  
  // console.log('currSectId:',currSectId)
  const currLayerId = useAppSelector(state => state.content.currLayerId)  
  // console.log('currLayerId:',currLayerId)
  const currLayerOrder = useAppSelector(state => state.content.currLayerOrder)  
  // console.log('currLayerOrder:',currLayerOrder)

  const hoverSectId = useAppSelector(state => state.content.hoverSectionId)  
  // console.log('hoverSectId:',hoverSectId)
  const hoverLayerId = useAppSelector(state => state.content.hoverLayerId)  
  // console.log('hoverLayerId:',hoverLayerId)
  const hoverLayerOrder = useAppSelector(state => state.content.hoverLayerOrder)  
  // console.log('hoverLayerOrder:',hoverLayerOrder)
  const hoverLayerSourceId = useAppSelector(state => state.content.hoverLayerSourceId)  
  // console.log('hoverLayerSourceId:',hoverLayerSourceId)
  
  const selectedLayer = currPersistContent.elements.find((sect)=>sect.element_id === currSectId)?.sources.find((layer)=>layer.source_list_id === currLayerId)
  // console.log('selectedLayer:',selectedLayer)
  // console.log("...selectedLayer", {...selectedLayer})
  const newTmpltSetting = useAppSelector(state => state.editor.templateToolsSettings)
  // console.log("newTmpltSetting in EditorTools: ", newTmpltSetting)

  // --------------------------------------------------
  const handleDeleteSrc = (sect: Element, src: Source) => {    

    try{
        
      // Remove a src from the currContentSection
      // -------------------------------------------------
      const recentSect = currPersistContent.elements.find((ele)=> {return ele.element_id === sect.element_id})

      var sourceList: Source[] = recentSect 
                                      ? (recentSect.sources
                                          ? recentSect.sources.filter((s)=> {                            
                                              return s.source_list_id !== src.source_list_id
                                            })
                                          : []
                                        )
                                      : [] 

      // Rendering the order of the sources
      sourceList = sourceList.map((s, ind) => {
        return {...s, order: (sourceList.length - ind)}
      })        
      // console.log("sourceList after: ",sourceList)      
      // console.log("sourceList after: ",sourceList.map((src) => {return src?.order}))

      dispatch(setSectionId(sect.element_id))  //which section it belongs to
      dispatch(setContentSource(sourceList))                

      dispatch(setHoverLayerId(sourceList.length<=0 ? "": sourceList[0].source_list_id))  //which section it belongs to
      dispatch(setHoverLayerOrder(sourceList.length))  //which section it belongs to
      dispatch(setHoverLayerSourceId(sourceList.length<=0 ? "": sourceList[0].source_id))

            
    }catch(error){
      Swal.fire(
          'Source: '+ src.element_id,
          'There is something wrong during the deletion!',
          'error'
      )                                    
    } 
  }


  // ---------------------------------------------------------
  const handleSwappingSrcs = (sect: Element, hoverLayerOrder: number, funcName: "swap up" | "swap down" | "go first" | "go last" = "swap up") => {    
    if (hoverLayerOrder > 0){
      try{
        // convert in order to get the correct order
        const matchingOrder = sect.sources.length - hoverLayerOrder
        var newSourceList: Source[] = []

        if (funcName === "swap up") { // Swap Up
          newSourceList = [
            ...sect.sources.slice(0, matchingOrder),
            ...sect.sources.slice(matchingOrder+1, matchingOrder+2),  // Swaping position
            ...sect.sources.slice(matchingOrder, matchingOrder+1),  // Swaping position            
            ...sect.sources.slice(matchingOrder+2)
          ]
        }else if (funcName === "swap down"){  // Swap Down
          newSourceList = [
            ...sect.sources.slice(0, matchingOrder-1),
            ...sect.sources.slice(matchingOrder, matchingOrder+1),  // Swaping position
            ...sect.sources.slice(matchingOrder-1, matchingOrder),  // Swaping position
            ...sect.sources.slice(matchingOrder+1)
          ]
        }else if (funcName === "go first"){  // Go first
          newSourceList = [
            ...sect.sources.slice(0, matchingOrder),
            ...sect.sources.slice(matchingOrder+1),
            ...sect.sources.slice(matchingOrder, matchingOrder+1),  // Swaping position
          ]
        }else if (funcName === "go last"){  // Go last
          newSourceList = [
            ...sect.sources.slice(matchingOrder, matchingOrder+1),  // Swaping position
            ...sect.sources.slice(0, matchingOrder),
            ...sect.sources.slice(matchingOrder+1)
          ]
        }
        
        // Rendering the order of the sources
        newSourceList = newSourceList.map((s, ind) => {
          return {...s, order: (newSourceList.length - ind)}
        })
          
        dispatch(setSectionId(sect.element_id))  //which section it belongs to
        dispatch(setContentSource(newSourceList))                

        // remove the highlight after click move UP/Down
        // dispatch(setSectionId(""))
        // dispatch(setLayerId(""))  
              
      }catch(error){
        Swal.fire(
            'There is something wrong during the swapping!',
            'error'
        )                                    
      } 
    }else{
      console.log("Warning: hoverLayerOrder is smaller than 0.")
    }
  }

  // const [expanded, setExpanded] = useState<false | string>(false);
  // const handleChange = (panel: string) => (event: SyntheticEvent, isExpanded: boolean) => {
  //   console.log("panel", panel)
  //   console.log("isExpanded", isExpanded)
  //   // console.log("iconClick", iconClick)
  //   // setExpanded(isExpanded ? panel : false);
  // };
  
  // const accordionProps = {
  //   sx: {
  //     pointerEvents: "none"
  //   },
  //   expandIcon: (<>      
  //     <ExpandMoreIcon
  //       sx={{
  //         pointerEvents: "auto"
  //       }}
  //     />
  //     <SettingsSuggest
  //       sx={{
  //         pointerEvents: "auto"
  //       }}        
  //     />
  //   </>)
  // };
    

  //-----------------------------------------
  return (    
    <Accordion 
      // TransitionProps={{ unmountOnExit: true }}
      defaultExpanded={true}
      square={true}
      disableGutters={true}   
      className='pb-2 border border-0'  
      style={{borderLeft: "0px"}}                
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
        className='p-3'        
        style={{backgroundColor:"#1e1e2d88"}}        
      >
        <Typography>
          <KTSVG path='/media/icons/duotune/layouts/lay001.svg' className='svg-icon-3 text-white me-2'/>
          <span className='text-white fw-semibold'>Template Sections</span>
        </Typography>
      </AccordionSummary>
      <AccordionDetails
        className='m-0 p-0 mh-500px overflow-auto'      
      >
        {currPersistTemplate.positions?.slice().reverse()
        .map((sect, sectIndex)=> { 
          // console.log("Sect: ", sect)
          // const sectDuration = sect.sources.reduce(
          //   (accumulator, currentSrc) => accumulator + (currentSrc.param_source[0].duration?currentSrc.param_source[0].duration:0)
          //   , 0
          // )
          // // console.log("sect.sources:", sect.sources)
          // const clsNames = unselectedSectIds.includes(sect.element_id) ? ["text-gray-300", "bg-light"]:["text-muted",""]
          const clsNames = ["text-muted",""]
          const isSelectedFlag = newTmpltSetting.selectedSect === sect.alias
          // -------------------------------
          return (
            <Accordion
              key={`posSect-${sectIndex}`} 
              defaultExpanded={true}
              square={true}
              disableGutters={true}
              // disabled={true}  
              // expanded={expanded === `sect-${sect.element_id}`} 
              // onChange={handleChange(`sect-${sect.element_id}`)}   
              className='border border-0'
              style={{
                borderLeft: "0px",                
              }}              
            >
              <div className=''>
                <AccordionSummary
                  // {...accordionProps}
                  expandIcon={<ExpandMoreIcon/>}                             
                  aria-controls={`sect-${sect.alias}`}
                  id={`sect-${sect.alias}-header`}
                  className={`px-3 ${isSelectedFlag ? "bg-light-primary border border-2 border-primary":"bg-light border-0"} `}
                  // style={{ borderLeft: "0px" }}                    
                  // style={{ color:"#331168"   }}
                > 
                  <div className={`d-flex justify-content-between w-100`}>
                    <div className={`ms-3 ${clsNames[0]} `}>
                      <span className={`w-20px`}>
                        {getSectionIcon(sect.element_type, isSelectedFlag ? "text-primary": clsNames[0] )}
                      </span>                                          
                      <span className={`text-capitalize ${isSelectedFlag ? "text-primary":""}`}>{sect.element_type}</span> 
                      <span className={`badge ${isSelectedFlag ? "badge-white text-primary":"badge-secondary "} fs-9 ms-1 pb-1`}>{sect.alias}</span> 
                    </div>
                    
                    {/* <div className="position-absolute top-0 start-0 opacity-100"
                      style={{paddingTop: "1px", paddingLeft: "5px"}}                      
                    >
                      <i className="fa fa-eye text-muted text-hover-primary shadow-sm" style={{fontSize: "9px"}}                          
                          ></i>                      
                    </div> */}
                    

                    {/* {sect.element_setting && sect.element_setting.transition &&
                    <div 
                      className='d-flex text-link text-hover-primary'
                      data-bs-toggle="offcanvas"
                      aria-controls="staticBackdrop"
                      data-bs-target="#kt_drawer_edit_section"
                      // onClick={handleIconClick(`sect-${sect.element_id}`)}
                      onClick={()=>{
                        // handleIconClick(`sect-${sect.element_id}`)
                        dispatch(setSectionId(sect.element_id))
                      }}
                    >         
                      <span className="fs-9 text-capitalize opacity-75 h-15px mt-0 ms-5">                    
                        {sect.element_setting.transition_timer>0? (sect.element_setting.transition_timer/1000.0)+"s ":" "} 
                        {sect.element_setting.transition &&
                          <i className={`${TransitionList[sect.element_setting.transition]} fs-8 ms-1 me-2`} title={toCapitalize(sect.element_setting.transition)}></i>
                        }                      
                      </span> 
                      <span className="badge badge-secondary text-white fs-9 py-0 px-1 h-15px me-1">
                        {sectDuration >0? secondsToHHmmss(sectDuration): ""}                       
                      </span>                    
                    </div>
                    } */}
                  </div>
                </AccordionSummary>
              </div>
              
              <AccordionDetails
                className={`ps-10 py-3 pe-10 ${isSelectedFlag ? "bg-light border border-2 border-primary border-top-0":""}`}
                onClick={(e)=> dispatch(setTemplateSettings({...newTmpltSetting, selectedSect: sect.alias}))}                
                // id="kt_drawer_edit_contents_button"
                // data-kt-drawer-show="true"
              >                 
                <div className="d-flex justify-content-between">
                  <div>X:</div>
                  <div>{sect.x}</div>
                </div>
                <div className="d-flex justify-content-between">
                  <div>Y:</div>
                  <div>{sect.y}</div>
                </div>
                <div className="d-flex justify-content-between">
                  <div>Width:</div>
                  <div>{sect.w}</div>
                </div>
                <div className="d-flex justify-content-between">
                  <div>Height:</div>
                  <div>{sect.h}</div>
                </div>
                {/* <div className="d-flex justify-content-between">
                  <div>(x,y):</div>
                  <div>(w,h):</div>
                </div>
                <div className="d-flex justify-content-between">
                  <div>{sect.x}, {sect.y}</div>
                  <div>{sect.w}, {sect.h}</div>
                </div>                 */}
              </AccordionDetails>
            </Accordion>
          )}
        )}
      </AccordionDetails>
    </Accordion>
  )
}

export {AccordionTemplateSections}